/**
 * Http Methods allowed in this application.
 */
export enum HttpMethod {
	GET = "GET",
	POST = "POST",
	PUT = "PUT",
	DELETE = "DELETE",
	PATCH = "PATCH",
	OPTIONS = "OPTIONS"
}
